<glxy-confirmation-body>
  <mat-icon glxyConfirmationIcon class="icon" inline="true" color="primary">key</mat-icon>
  <glxy-confirmation-title>{{
    'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.IMPERSONATE_USER' | translate
  }}</glxy-confirmation-title>

  <glxy-confirmation-message>
    {{
      'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.IMPERSONATE_INTO_ACCOUNT' | translate: { accountName: data.companyName }
    }}
  </glxy-confirmation-message>

  <glxy-confirmation-custom-content>
    <glxy-form-field>
      <input
        type="text"
        [placeholder]="'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.SELECT_A_USER' | translate"
        [attr.aria-label]="'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.SELECT_A_USER' | translate"
        matInput
        [formControl]="selectedUserFormControl"
        [matAutocomplete]="auto"
        [required]="false"
      />
      <mat-spinner *ngIf="loading" matPrefix diameter="24"></mat-spinner>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredOptions$ | async; track option) {
          <mat-option [value]="option">{{ option.descriptiveName }}</mat-option>
        }
      </mat-autocomplete>
      <glxy-error *ngIf="!loading && selectedUserFormControl.touched && selectedUserFormControl.hasError('required')">
        {{ 'MANAGE_ACCOUNTS.IMPERSONATE_USER_DIALOG.USER_REQUIRED' | translate }}
      </glxy-error>
    </glxy-form-field>
  </glxy-confirmation-custom-content>
</glxy-confirmation-body>

<glxy-confirmation-actions>
  <glxy-confirmation-primary-actions>
    <button mat-stroked-button matDialogClose>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="impersonateUser()">
      {{ 'COMMON.ACTION_LABELS.IMPERSONATE' | translate }}
    </button>
  </glxy-confirmation-primary-actions>
</glxy-confirmation-actions>
